<template>
  <div class="calendar-container">
    <div class="title d-flex justify-content-between">
        <span @click="updateMonth(-1)" class="icon">&lt;</span>
        <span>{{months[firstDayMonth.getMonth()]}} {{firstDayMonth.getFullYear()}}</span>
        <span @click="updateMonth(1)" class="icon">&gt;</span>
    </div>
    <table>
      <thead>
        <tr>
          <th>L</th>
          <th>M</th>
          <th>M</th>
          <th>J</th>
          <th>V</th>
          <th>S</th>
          <th>D</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(week, weekNo) of daysPerWeek" :key="weekNo">
          <td v-for="(day, dayNo) of week"
              :key="(dayNo + 1) + (weekNo + 1) * 7"
              :class="{
              disabled: day < today || day.getMonth() != firstDayMonth.getMonth(),
          weekend: day.getDay() == 6 || day.getDay() == 0,
          'due-date': dueDates[formatDate(day)] != undefined,
          'priority-none': dueDates[formatDate(day)] != undefined && dueDates[formatDate(day)] == 4,
          'priority-minor': dueDates[formatDate(day)] && dueDates[formatDate(day)] == 3,
          'priority-major': dueDates[formatDate(day)] && dueDates[formatDate(day)] == 2,
          'priority-blocking': dueDates[formatDate(day)] && dueDates[formatDate(day)] == 1
          }">
          <div @click="$emit('filterDue', formatDate(day))">
          {{day.getDate()}}
          </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="filter d-flex justify-content-between" v-if="dueFilter">
      <span>{{formatDate(new Date(dueFilter), true)}}</span><span><font-awesome-icon class="icon" icon="times" @click="$emit('filterDue', '')" /></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TrelloCalendar",
    props: {
      cards: Array,
      dueFilter: String
    },
    data() {
      const today = new Date();
      today.setMinutes(0)
      today.setHours(0)
      today.setSeconds(0)

      const firstDayMonth = new Date();
      firstDayMonth.setDate(1)

      const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
      return {
        today,
        months,
        firstDayMonth,
        days: this.getDaysList(firstDayMonth)
      }
    },
    methods: {
      getDaysList(period = new Date()) {
        const res = []
        const month = period.getMonth()
        const year = period.getFullYear()
        const firstMonthDay = new Date(period)
        firstMonthDay.setDate(1)
        const firstCalendarDay = new Date(period)
        if (firstMonthDay.getDay() != 1)
          firstCalendarDay.setDate(firstMonthDay.getDate() - ((firstMonthDay.getDay() == 0 ? 7 : firstMonthDay.getDay()) - 1))
        const current = new Date(firstCalendarDay)
        while (
          current.getFullYear() < year || // pour les derniers jouers N - 1 (sur décembre alors qu'on est en janvier)
          (current.getFullYear() === year && current.getMonth() <= month) ||
          current.getDay() !== 0
          // (current.getMonth() <= month && current.getFullYear() <= year)
        ) {
          // Tant qu'on arrive pas au dimanche du mois prochain
          res.push(new Date(current))
          current.setDate(current.getDate() + 1)
        }
        res.push(new Date(current))
        return res
      },
      updateMonth(step) {
        this.firstDayMonth.setMonth(this.firstDayMonth.getMonth() + step);
        this.firstDayMonth = this.firstDayMonth
        this.days = this.getDaysList(this.firstDayMonth)
      },
      formatDate(dateObj, display=false) {
        if (!display)
          return `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1 < 10) ? "0" : ""}${dateObj.getMonth() + 1}-${(dateObj.getDate() < 10) ? "0" : ""}${dateObj.getDate()}`
        return `${(dateObj.getDate() < 10) ? "0" : ""}${dateObj.getDate()}/${(dateObj.getMonth() + 1 < 10) ? "0" : ""}${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`
      }
    },
    computed: {
      daysPerWeek() {
        return this.days.reduce((acc, current, index) => {
          const currentWeek = parseInt(index / 7);
          if (acc.length <= currentWeek) acc.push([]);
          acc[currentWeek].push(current);
          return acc
        }, [])
      },
      dueDates() {
        let res = {}
        this.cards
          .filter(card => card.due)
          .forEach(card => {
            const dueDate = this.formatDate(new Date(card.due));
            if (!res[dueDate] || res[dueDate] > card.priorityLevel)
              res[dueDate] = card.priorityLevel
          })
        return res;
      }
    }
  }
</script>

<style scoped>
  .calendar-container {
    padding: 1rem;
    border-radius: 12px;
    background-color: white;
    box-shadow: 1px 1px 8px 0 rgba(0, 0, 0, 0.4);
    height: min-content;
  }

    .calendar-container .title {
      font-weight: bold;
      padding-bottom: 0.3rem;
      margin-bottom: 0.3rem;
      border-bottom: 1px solid #EEE;
    }

    .calendar-container .title .icon:hover {
      cursor: pointer;
    }


    .calendar-container table {
      width: 100%;
      text-align: center;
    }

      .calendar-container table th {
        color: #A7C13C;
      }
      .calendar-container table td div {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        aspect-ratio: 1/1;
      }

      .calendar-container table td div:hover {
        cursor: pointer;
      }

      .calendar-container table td.disabled {
        color: #CCC;
      }

      .calendar-container table td.weekend {
        background-color: #F2F2F2;
      }

      .calendar-container table td.priority-none div {
        border: 1px solid #888;
      }

      .calendar-container table td.priority-minor div {
        background-color: rgb(237, 215, 71);
      }

      .calendar-container table td.priority-major div {
        background-color: rgb(242, 162, 64);
      }

      .calendar-container table td.priority-blocking div {
        background-color: rgb(218, 100, 79);
      }

      .filter {
        margin-top: 0.5rem;
        padding-top: 0.5rem;
        border-top: 1px solid #EEE;
      }

      .filter .icon:hover {
        cursor: pointer;
      }
</style>



// WEBPACK FOOTER //
// src/components/TrelloCalendar.vue